//views/callback.vue

<template>
  <Loading/>
</template>

<script lang="ts">
import Loading from "../components/LoadingP.vue";
import {handleKeycloakCallback} from "../core/callback.js";
import {mapActions} from "vuex";

export default {
  name: 'KeycloakCallback',
  components: {
    Loading
  },
  methods: {
    ...mapActions('account', ['registerUser', 'login', 'getUserProfile']),
  },
  async mounted() {
    await handleKeycloakCallback(
        this.$store,
        this.$router,
        this.$route,
        this.registerUser,
        this.login,

    );

  }
};
</script>
